import styled from '@emotion/styled';

export const Description = styled.p`
  white-space: pre-line;
`;
